import { Navigate, Outlet } from "react-router-dom";
import jwt from "jwt-decode";

export default function ProtectedRoute({ redirectPath = "/" }) {
  const token = localStorage.getItem("@medusapayments:access_token");

  let isValid = false;

  if (token) {
    const unscrypted = jwt(token);
    isValid = !!unscrypted.exp && !!unscrypted.iat && !!unscrypted.emp_id;

    if (unscrypted.exp && unscrypted.exp < Date.now() / 1000) {
      // Tempo do token expirado, limpar o armazenamento
      localStorage.removeItem("@medusapayments:access_token");
      return <Navigate to={redirectPath} replace />;
    }
  }

  // Verificar o tempo de expiração do token a cada segundo
  setInterval(() => {
    const token = localStorage.getItem("@medusapayments:access_token");

    if (token) {
      const unscrypted = jwt(token);

      if (unscrypted.exp && unscrypted.exp < Date.now() / 1000) {
        // Tempo do token expirado, limpar o armazenamento
        localStorage.removeItem("@medusapayments:access_token");
        window.location.reload(); // Recarregar a página para refletir as alterações
      }
    }
  }, 1000);

  if (!token || !isValid) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
}
